/**
 * Allergies Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    allergies: [],
    allergy: {}
};

// Getters
const getters = {
    allergies: state => {
        return state.allergies
    },

    allergy: state => {
        return state.allergy
    }
};

// Actions
const actions = {
    getAllergies(context, payload) {
        function successCallback(response) {
            context.commit('getAllergiesHandler', { allergies: response.data.allergies });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Allergy.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getAllergy(context, payload) {
        function successCallback(response) {
            context.commit('getAllergyHandler', { allergy: response.data.allergie });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Allergy.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createAllergy(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'allergies' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Allergy.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    addAllergy(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
// Liste des retours possibles
            // router.push({ name: 'medical-file', params: { file: response.data.dossier.slug }  });
            // router.push({ name: 'allergies' });
            // router.back();
            context.commit('getMedicalFileHandler', { file: response.data.dossier });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Allergy.Add, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    addAllergyVersion(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
// Liste des retours possibles
            // router.push({ name: 'medical-file', params: { file: response.data.dossier.slug }  });
            // router.push({ name: 'allergies' });
            // router.back();
            context.commit('getMedicalFileHandler', { file: response.data.dossier });
            context.commit('setAllergieHandler', { allergies: response.data.dossier.allergies });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Allergy.AddAgain, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateAllergy(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            // router.push({ name: 'allergies' });
            // router.push({ name: 'medical-file', params: { file: response.data.dossier.slug }  });
            store.dispatch('findAndRemove', {name: 'allergy' });
            router.push({ name: 'allergy', params: { allergy: response.data.allergie.slug } });
            // router.back();
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Allergy.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteAllergy(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }
        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Allergy.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    removeAllergy(context, payload) {
        function successCallback(response) {
            context.commit('getMedicalFileHandler', { file: response.data.dossier });
            context.commit('setAllergieHandler', { allergies: response.data.dossier.allergies });

            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Allergy.Remove, localToken, successCallback, errorCallback, payload.errorMessages);
    },

};

// Mutations
const mutations = {
    getAllergiesHandler(state, { allergies }) {
        // Update allergies state
        state.allergies = allergies;
    },

    getAllergyHandler(state, { allergy }) {
        // Update allergy state
        state.allergy = allergy;
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}